(function () {

	'use strict';

	/*global $:true */

	let cologicSortByTags = {

		initSortByTags: function () {

			// let that = this;
            //
			// this.showToTop();
			// this.setBurger();
			// this.enableAccordion();
			// // this.navigationHandling();
			// // this.setYoutubeBox();
            //
			// $('.toTopWrapper').click(this.pageToTop);
			// // $(window).scroll(function () {
			// // 	that.setBackgroundImages();
			// // 	that.showToTop();
			// // });
			// // setTimeout(function () {
			// // 	that.setBackgroundImages()
			// // }, 1500);
            //
			// this.equalHeight();

		},


        identifyDataTags: function (_classes) {

            if (typeof(_classes) != 'undefined' && _classes != null && _classes !== ''){
                let dataTags = [];
                _classes.forEach((_class)=>{
                    $(_class).each(function(){
                        let json_data = $(this).data();
                        for(let i in json_data){
                            if(typeof(dataTags[i]) != 'undefined'){
                                dataTags[i].push(json_data [i].trim().split(' '));
                            }else{
                                dataTags[i] = [];
                                dataTags[i].push(json_data [i].trim().split(' '));
                            }
                        }
                    });
                });
                return dataTags;
            }else{
                return [];
            }
		},



        enableTagButtonsForDataTags: function (_dataTags) {
            let urlstring = window.location.href.toString();
            let useHersteller = false;
            let useArt = true;
            let useMaterial = false;
            let useModell = false;
            if(urlstring.indexOf('produkte/nomos-uhren') != -1){
                useModell = true;
            }
            if(urlstring.indexOf('/schmuck/uhren') != -1){
                useHersteller = true;
            }
            let out = '';
            // out += '<h3 class="tagSectionHead">Aktuelle Kategorien (zum ein-/ausblenden klicken)</h3>';
            out += '<div class="tagSection pt-2">';
            let procArray = [];
            // console.log(_dataTags);
            let outArt = '';
            let outMaterial = '';
            for(let i in _dataTags){
                procArray[i] = [];
                // console.log(i);
                // console.log(_dataTags[i]);
                // console.log(_dataTags[i]);
                // if(_dataTags[i][0] != ''){
                    _dataTags[i].forEach((selectTag) =>{
                        // console.log(selectTag);
                            selectTag.forEach((tag) => {
                                if(typeof(procArray[i][tag]) == 'undefined') {
                                    if(tag != ''){
                                        procArray[i][tag] = 1;
                                        let fineTag = tag.charAt(0).toUpperCase()  + tag.slice(1);
                                        if(tag == 'schoenedinge'){
                                            fineTag = 'Schöne Dinge';
                                        }
                                        if(tag == 'tangente-38-datum'){
                                            fineTag = 'Tangente 38 Datum';
                                        }
                                        // console.log(i);


                                        switch(i){
                                            case 'hersteller':
                                                if(useHersteller){
                                                    outArt += '<div class="btn tagBtn active ' + i + '" data-wert="' + tag + '" data-kategorie="' + i + '">' + fineTag + '</div>';
                                                }
                                                break;

                                            case 'art':
                                                if(useArt){
                                                    outArt += '<div class="btn tagBtn active ' + i + '" data-wert="' + tag + '" data-kategorie="' + i + '">' + fineTag + '</div>';
                                                }
                                                break;

                                            case 'modellreihe':
                                                if(useModell){
                                                    outArt += '<div class="btn tagBtn active ' + i + '" data-wert="' + tag + '" data-kategorie="' + i + '">' + fineTag + '</div>';
                                                }
                                                break;

                                            case 'material':
                                                if(useMaterial){
                                                    outArt += '<div class="btn tagBtn active ' + i + '" data-wert="' + tag + '" data-kategorie="' + i + '">' + fineTag + '</div>';
                                                }
                                                break;


                                        }
                                    }
                                }
                            });
                    });
                    // out += '</div>';
                // }
            }
            out += '<div class="outRow initialState">' + outArt + '</div>';
            // out += '<div class="outRow">' + outMaterial + '</div>';
            out += '</div>';
            $('#contentMain .crawlContainer ').prepend(out);
            if($('.tagBtn.active.art').length < 2){
                $('.tagBtn.active.art').remove();
            }
            if($('.tagBtn.active.hersteller').length < 2){
                $('.tagBtn.active.hersteller').remove();
            }
            if($('.tagBtn.active.material').length < 2){
                $('.tagBtn.active.material').remove();
            }
            // if (typeof(_dataTags) != 'undefined' && _dataTags != null && _dataTags !== '' && _dataTags.length > 0){
            //     _dataTags.forEach((_dataTag)=>{
            //         console.log(_dataTag);
            //     });
            // }
            // setTimeout(function (){


            var isTouch =  ("ontouchstart" in window) || (navigator.maxTouchPoints > 0) || window.navigator.msMaxTouchPoints > 0 ;
            if( isTouch ) {
                // console.log('touch1');

                $('.proboOuter').each(function (){
                    $(this).bind('touchstart', function(){
                        // console.log('touchtouch');
                        if(!$(this).hasClass('touch')){
                            $(this).addClass('touch');
                            $(this).unbind('touchstart');
                        }
                    });
                });
            }else{
                // console.log('touch2');

                $('.proboOuter').each(function (){
                    $(this).bind('click', function(){
                        // console.log('touch');
                        $(this).toggleClass('touch');
                    });
                });
            }
            $('.tagBtn').each(function (){

                if( isTouch ){
                    $(this).bind('touchstart', function(){
                        let that = this;
                        $('.tagBtn').each(function (){
                            if(!$(this).hasClass('active')){
                                let kategorie = $(this).data('kategorie');
                                let wert = $(this).data('wert');
                                let found = false;
                                $('.probo').each(function(){
                                    if($(this).data(kategorie).indexOf(wert) != -1){
                                        // $(this).toggleClass(kategorie);
                                        // $(this).toggleClass(wert);
                                        $(this).parent().parent().removeClass('active');
                                    }
                                });
                            }

                        });
                        let kategorie = $(this).data('kategorie');
                        let wert = $(this).data('wert');
                        let found = false;
                        $('.probo').each(function(){
                            if($(this).data(kategorie).indexOf(wert) != -1){
                                found = true;
                                // $(this).toggleClass(kategorie);
                                // $(this).toggleClass(wert);
                                if($(that).hasClass('active')) {
                                    $(this).parent().parent().removeClass('active');
                                }else{
                                    $(this).parent().parent().addClass('active');
                                }
                            }
                        });
                        // setTimeout(function (){

                        if(found){
                            $(this).toggleClass('active');
                        }

                        // },300);


                    });
                }else{
                    $(this).bind('click', function(){
                        let that = this;
                        if($(this).parent().hasClass('initialState')){
                            $('.tagBtn').each(function (){
                                if(this != that){
                                    let kategorie = $(this).data('kategorie');
                                    let wert = $(this).data('wert');
                                    // console.log(kategorie);
                                    let found = false;
                                    $('.probo').each(function(){
                                        if($(this).data(kategorie).indexOf(wert) != -1){
                                            // $(this).toggleClass(kategorie);
                                            // $(this).toggleClass(wert);
                                            $(this).parent().parent().removeClass('active');
                                        }
                                    });
                                    $(this).removeClass('active')
                                }

                            });
                            $('.tagBtn').each(function (){
                                if(this == that){
                                    let kategorie = $(this).data('kategorie');
                                    let wert = $(this).data('wert');
                                    // console.log(kategorie);
                                    let found = false;
                                    $('.probo').each(function(){
                                        if($(this).data(kategorie).indexOf(wert) != -1){
                                            // $(this).toggleClass(kategorie);
                                            // $(this).toggleClass(wert);
                                            $(this).parent().parent().addClass('active');
                                        }
                                    });
                                }

                            });
                            $(this).parent().removeClass('initialState')


                        }else{
                            $('.tagBtn').each(function (){
                                if(!$(this).hasClass('active')){
                                    let kategorie = $(this).data('kategorie');
                                    let wert = $(this).data('wert');
                                    let found = false;
                                    $('.probo').each(function(){
                                        if($(this).data(kategorie).indexOf(wert) != -1){
                                            // $(this).toggleClass(kategorie);
                                            // $(this).toggleClass(wert);
                                            $(this).parent().parent().removeClass('active');
                                        }
                                    });
                                }

                            });
                            let kategorie = $(this).data('kategorie');
                            let wert = $(this).data('wert');
                            let found = false;
                            $('.probo').each(function(){
                                if($(this).data(kategorie).indexOf(wert) != -1){
                                    found = true;
                                    // $(this).toggleClass(kategorie);
                                    // $(this).toggleClass(wert);
                                    if($(that).hasClass('active')) {
                                        $(this).parent().parent().removeClass('active');
                                    }else{
                                        $(this).parent().parent().addClass('active');
                                    }
                                }
                            });
                            // setTimeout(function (){

                            if(found){
                                $(this).toggleClass('active');
                            }

                            // },300);

                        }


                    });
                }

                });

            // },600);
		},






	};

	//------------------------------------

	//gemeinsam verfügbar machen
	if (typeof (cologic) === 'undefined')
		window.cologic = {};
	$.extend(cologic, cologicSortByTags);
}());